// https://serverless-stack.com/chapters/configure-aws-amplify.html
// https://serverless-stack.com/chapters/environments-in-create-react-app.html
const config = {
    apiGateway: {
        REGION: "YOUR_DEV_API_GATEWAY_REGION",
        URL: process.env.REACT_APP_API_URL,
        DEFAULT_VERSION: process.env.REACT_APP_API_DEFAULT_VERSION
    },
    cognito: {
        REGION: "YOUR_DEV_COGNITO_REGION",
        USER_POOL_ID: "YOUR_DEV_COGNITO_USER_POOL_ID",
        APP_CLIENT_ID: "YOUR_DEV_COGNITO_APP_CLIENT_ID",
        IDENTITY_POOL_ID: "YOUR_DEV_IDENTITY_POOL_ID"
    },
    openIdDict: {
        CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
        CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
        LOGOUT_URI: process.env.REACT_APP_LOGOUT,
        TOKEN_URI: process.env.REACT_APP_TOKEN_URI,
        AUTH_URI: process.env.REACT_APP_AUTH_URI,
        REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI
    },
    build: {
        number: process.env.REACT_APP_BUILD_NUMBER,
    },
};

export default config;